import { SortAsc, SortDesc } from 'lucide-react';

import SORT_OPTIONS from '@/shared/constants/centersSortOptions';
import { cn } from '@/shared/utils';

import Button from '@/components/ui/button';

const LABELS = {
  [SORT_OPTIONS.GAMES]: 'Order by games',
  // [SORT_OPTIONS.VIEWERS]: 'Order by viewers',
  [SORT_OPTIONS.PROXIMITY]: 'Order by proximity',
};

const Icon = {
  asc: <SortAsc size={24} />,
  desc: <SortDesc size={24} />,
};

/**
 * Renders a navigation component with order options.
 * @returns {JSX.Element} The rendered navigation component.
 */
const Sort = ({
  value = {
    order: SORT_OPTIONS.GAMES,
    sort: 'asc',
  },
  onChange,
}) => {
  return (
    <nav className="flex gap-2 overflow-x-auto -mx-8 px-8 md:p-0 md:mx-0 max-w-[100vw]">
      <Button
        className={cn(
          'flex gap-2.5 py-2 md:py-1 border-2 border-solid text-white/60 normal-case rounded-full',
          value.order === SORT_OPTIONS.GAMES
            ? 'border-white/60 text-white/60'
            : 'border-transparent',
          'hover:text-white/60 hover:bg-transparent hover:border-white/60'
        )}
        onClick={() => {
          onChange({
            order: SORT_OPTIONS.GAMES,
            sort: value.sort === 'asc' ? 'desc' : 'asc',
          });
        }}
        data-cy="sort-by-games"
      >
        {LABELS[SORT_OPTIONS.GAMES]}
        {value.order === SORT_OPTIONS.GAMES && Icon[value.sort]}
      </Button>
      <Button
        className={cn(
          'flex gap-2.5 py-2 md:py-1 border-2 border-solid text-white/60 normal-case rounded-full',
          value.order === SORT_OPTIONS.PROXIMITY
            ? 'border-white/60 text-white/60'
            : 'border-transparent',
          'hover:text-white/60 hover:bg-transparent hover:border-white/60'
        )}
        onClick={() =>
          onChange({
            order: SORT_OPTIONS.PROXIMITY,
            sort: 'desc',
          })
        }
        data-cy="sort-by-proximity"
      >
        {LABELS[SORT_OPTIONS.PROXIMITY]}
      </Button>
    </nav>
  );
};

export default Sort;
